class Textarea {
  constructor (el) {
    this.el = el
    this.field = this.el.querySelector('textarea')
    this.counterValue = this.el.querySelector('.js-textarea-value')
    this.max = parseInt(this.el.getAttribute('data-max'))

    this.initDefaults()
  }

  initDefaults () {
    this.initEvents()
  }

  initEvents () {
    this.field.addEventListener('input', e => this.onInput(e))
  }

  onInput (e) {
    this.field.style.height = 'auto'
    this.field.style.height = `${this.field.scrollHeight}px`
    this.setCounter()
  }

  setCounter () {
    const count = parseInt(this.field.value.length)
    const diff = this.max - count
    if (diff >= 0) {
      this.counterValue.innerHTML = this.max - count
    } else {
      this.field.value = this.field.value.slice(0, this.max)
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelectorAll('.js-textarea')

  if ( el.length ) {
    el.forEach(el => {
      new Textarea(el)
    })
  }
})